export default {
  title: 'Articoli',
};
